import { useTeaAggregatedData } from '@/stores/pathwayTemplateAnalysisStore';
import { getUnitAggregated, normalize } from '@/utils/pathwayTemplateUtils';
import LoadingSkeleton from '../core/LoadingSkeleton';
import SharedStackedBarChart from './SharedStackedBarChart/SharedStackedBarChart';

const CostsStackedBarChart = () => {
  const { data, loading, error } = useTeaAggregatedData();

  if (loading && !data) return <LoadingSkeleton />;
  if (error) return <div>Error: {error.message}</div>;

  const feedstocCosts = normalize(data?.costs, 'category', 'amount') || [];
  const unit = getUnitAggregated(data);

  return (
    <SharedStackedBarChart
      unit={unit}
      items={feedstocCosts}
      type="costs"
      title={`Costs by Component (${unit})`}
      emptyMessage="No costs data available"
    />
  );
};

export default CostsStackedBarChart;
